'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _query = require('utilities/query');

var _attest = require('./attest.html');

var _attest2 = _interopRequireDefault(_attest);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

exports.default = {
  templateUrl: _attest2.default,
  transclude: {
    actionButtons: '?actionButtons'
  },
  bindings: {
    adverseEvents: '<',
    onAttested: '&'
  },
  controller: function () {
    function AttestComponent(EventEmitter) {
      'ngInject';

      _classCallCheck(this, AttestComponent);

      Object.assign(this, { EventEmitter: EventEmitter });
    }

    _createClass(AttestComponent, [{
      key: '$onInit',
      value: function $onInit() {
        this.query = _extends({}, (0, _query.getQuery)(), {
          take: 5
        });
        this.limitOptions = (0, _query.getLimitOptions)();
      }
    }, {
      key: 'onSubmit',
      value: function onSubmit() {
        this.onAttested(this.EventEmitter({
          signature: this.signature
        }));
      }
    }]);

    return AttestComponent;
  }()
};


// WEBPACK FOOTER //
// ./components/app/common/attest/attest.component.js